import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import { Dialog, Filters, SingleAction, Sort } from "../types";

export enum ExchangeRateListUrlFiltersEnum {
  query = "query",
  currencyCode = "currencyCode",
}

export enum ExchangeRateListUrlSortField {
  currencyCode = "currencyCode",
  exchangeRate = "exchangeRate",
  updated = "updated",
}

export type ExchangeRateListUrlSort = Sort<ExchangeRateListUrlSortField>;
export type ExchangeRateListUrlFilters = Filters<ExchangeRateListUrlFiltersEnum>;
export type ExchangeRateUrlDialog = "remove" | "edit" | "create";
export type ExchangeRateUrlQueryParams = Dialog<ExchangeRateUrlDialog>;
export type ExchangeRateListUrlDialog = "remove" | "create";
export type ExchangeRateListUrlQueryParams = Dialog<ExchangeRateListUrlDialog> &
  ExchangeRateListUrlFilters &
  ExchangeRateListUrlSort &
  SingleAction;

export const exchangeRateSection = "/exchange-rates/";

export const exchangeRateListPath = exchangeRateSection;

export const exchangeRateListUrl = (params?: ExchangeRateListUrlQueryParams) =>
  exchangeRateListPath + "?" + stringifyQs(params);

export const exchangeRateAddPath = urlJoin(exchangeRateSection, "add");
export const exchangeRateAddUrl = exchangeRateAddPath;

export const exchangeRatePath = (currencyCode: string) =>
  urlJoin(exchangeRateSection, encodeURIComponent(currencyCode));

export const exchangeRateUrl = (currencyCode: string, params?: ExchangeRateUrlQueryParams) =>
  exchangeRatePath(currencyCode) + "?" + stringifyQs(params);
